import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { CommonHttpOption } from '../../base/common-http-option';
import { CoreService } from '../../base/core';
import { ServiceRoute } from '../../base/service-route';

@Injectable({
  providedIn: 'root'
})
export class GuidanceService {

  constructor(private core: CoreService) { }

  getParents(): Observable<any>
  {
    return this.core.get(ServiceRoute.guidance.getParents, new CommonHttpOption().headers);
  }

  getChildsByParentId(params: any)
  {
    return this.core.get(ServiceRoute.guidance.getAllChildByParentId, new CommonHttpOption().headers, params);
  }

  getGuideByUrl(params: any): Observable<any>
  {
    return this.core.get(ServiceRoute.guidance.getParentGuidByRoute, new CommonHttpOption().headers, params);
  }

  getAllGuideBySearch(params: any): Observable<any>
  {
    return this.core.get(ServiceRoute.guidance.getAllGuideBySearch, new CommonHttpOption().headers, params);
  }

  getRootIdList(params: any): Observable<any>
  {
    return this.core.get(ServiceRoute.guidance.getRoot, new CommonHttpOption().headers, params);
  }
}
